import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["path",{"d":"M0 0h86v86H0z","mask":"url(#coinpanda-alt-mono_svg__a)","key":"svg-path"}],["defs",{"key":"svg-defs"}]]);